export default __webpack_public_path__ + "static/ac-furnance-minnesota-repair-3-23f7d811a7b2ae04b6ff8c0999535b58.jpg";